<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm2 md2>
        <v-layout wrap justify-center>
          <template v-for="(photos, j) in storage.product">
            <v-flex
              v-if="j < 2"
              :key="j"
              :xs6="storage.product.length > 1 ? true : false"
            >
                <v-img
                :src="baseURL + '/u/' + photos.photos[0]"
                height="100px"
                contain
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#FF2323"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
          </template>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm10 md10 pl-2>
        <v-layout wrap justify-center fill-height>
          <v-flex xs12 sm9 md9 lg9 xl10 text-left>
            <v-layout wrap justify-start style="line-height: 16px" fill-height>
              <v-flex xs12 align-self-start>
                <router-link
                  :to="
                    '/Products/' +
                    storage.product[0].productname +
                    '/' +
                    storage.product[0]._id
                  "
                >
                  <span
                    style="
                      font-family: poppinsmedium;
                      font-size: 16px;
                      color: #000000;
                    "
                  >
                    {{ storage.productname }}
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 13px;
                    color: #5e5e5e;
                  "
                >
                  Payment Method : {{ storage.method }}
                </span>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 13px;
                    color: #5e5e5e;
                  "
                >
                  Ordered On : {{ formatDate(storage.init_date) }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm3 md3 lg3 xl2 text-right>
            <v-layout wrap justify-end fill-height>
              <v-flex
                xs12
                align-self-start
                :text-right="$vuetify.breakpoint.name != 'xs' ? true : false"
                :text-left="$vuetify.breakpoint.name == 'xs' ? true : false"
              >
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  Rs. {{ storage.amount }}
                </span>
              </v-flex>
              <v-flex xs12 align-self-end text-right>
                <v-btn
                  small
                  tile
                  dark
                  depressed
                  block
                  :ripple="false"
                  color="#FF0000"
                  :to="'/Orders/' + storage.transaction_id"
                >
                  <span
                    style="font-family: poppinssemibold; font-size: 12px"
                    class="text-capitalize"
                  >
                    View Details
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage"],
  data() {
    return {
    };
  },
  beforeMount() {},
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
  },
};
</script>